import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import s from "./role.module.css";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Card, Grid } from "@mui/material";
import { addRole_api, getRoleById_api, updateRole_api } from "../api/role";
const AddRole = ({ setSubAdminPermission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const roleId = location?.state?.data?._id;
  const [isLoading, setisLoading] = useState(false);

  const [pageLength, setpageLength] = useState();
  const [search, setsearch] = useState("");
  const [pageCount, setpageCount] = useState(1);
  const [roleById, setroleById] = useState({});

  const [name, setname] = useState("");

  console.log(
    roleById,
    " roleById roleById roleById roleById roleById roleById roleById "
  );

  const allItems = {
    dashboard: false,
    users: false,
    liveDarshan: false,
    libraryMedia: false,
    mediaCategory: false,
    banner: false,
    featureMedia: false,
    tags: false,
    appData: false,
    blogs: false,
    puja: false,
    festivals: false,
    reviews: false,
    certificate: false,
    subscription: false,
    transaction: false,
    subscriptionTransaction: false,
    members: false,
    role: false,
  };

  const [permissions, setPermissions] = useState(allItems);

  const pagetype = location?.state?.pagetype;
  useEffect(() => {
    if (pagetype === "Edit") setname(location?.state?.data?.name);
  }, [location]);

  // const createRoleFunc = async () => {
  //   if (pagetype === "Add") {
  //     let temp = { ...permissions, name: name };

  //     try {
  //       let res = await addRole_api(temp);
  //       if (res.data.status) {
  //         navigate("/role-list");
  //         notificationHandler({ type: "success", msg: res.data.message });
  //       } else {
  //         notificationHandler({ type: "success", msg: res.data.message });
  //       }
  //     } catch (error) {
  //       notificationHandler({ type: "danger", msg: error.message });
  //       console.log(error);
  //     }
  //   }
  //   if (pagetype === "Edit") {
  //     let temp = { ...permissions, name: name };
  //     try {
  //       let res = await updateRole_api(temp, roleId);
  //       if (res.data.status) {
  //         navigate("/role-list");
  //         notificationHandler({ type: "success", msg: res.data.message });
  //       } else {
  //         notificationHandler({ type: "success", msg: res.data.message });
  //       }
  //     } catch (error) {
  //       notificationHandler({ type: "danger", msg: error.message });
  //       console.log(error);
  //     }
  //   }
  // };

  const handleCheckboxChange = (key) => {
    setPermissions((prevPermissions) => {
      const updatedPermissions = {
        ...prevPermissions,
        [key]: !prevPermissions[key], // Toggle the value
      };

      // Compute newData using the updated state
      let newData = Object.keys(updatedPermissions).filter(
        (k) => updatedPermissions[k]
      );

      setSubAdminPermission(newData); // Use the new state

      return updatedPermissions; // Update state correctly
    });
  };

  console.log(permissions, "This is the true status");

  // useEffect(() => {
  //   fetchRoleByIdFunc();
  // }, []);

  // async function fetchRoleByIdFunc(data) {
  //   setisLoading(true);
  //   try {
  //     const temp = {
  //       page: pageCount,
  //       limit: 8,
  //       search: search.trim(),
  //     };
  //     let res = await getRoleById_api(temp, roleId);
  //     if (res.data.status) {
  //       setroleById(res?.data?.data);
  //       setPermissions(res?.data?.data?.permission);
  //       setisLoading(false);
  //     } else {
  //       setisLoading(false);
  //       console.log("status false!");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  return (
    <>
      <Grid item xs={12}>
        <div className="form-group">
          <h3>Manage Permissions</h3>
          <ul>
            {Object.keys(permissions).map(
              (key, index) => (
                console.log(
                  key,
                  " this is all the key to give the role to the permission"
                ),
                (
                  <li
                    key={key}
                    style={{ listStyle: "none", marginBottom: "8px" }}
                  >
                    <label>
                      <input
                        type="checkbox"
                        checked={permissions[key]}
                        onChange={() => handleCheckboxChange(key)}
                      />
                      {` ${key}`}
                    </label>
                  </li>
                )
              )
            )}
          </ul>
          {/* <pre>{JSON.stringify(permissions, null, 2)}</pre> */}
        </div>
      </Grid>
    </>
  );
  // return (
  //   <>
  //     <div className="">
  //       <Card className={s["admin_container"]}>
  //         <div className={s["title"]} onClick={() => navigate(-1)}>
  //           <BiArrowBack />
  //           Back
  //         </div>
  //         <Grid
  //           container
  //           rowSpacing={1}
  //           columnSpacing={{ xs: 1, sm: 2, md: 3 }}
  //         >
  //           {/* <Grid item xs={12}>
  //             <div className="form-group">
  //               <label for="exampleInputEmail1"> Name</label>
  //               <input
  //                 type="text"
  //                 className="form-control"
  //                 value={name}
  //                 onChange={(e) => setname(e.target.value)}
  //                 placeholder="name"
  //               />
  //             </div>
  //           </Grid> */}
  //           <Grid item xs={12}>
  //             <div className="form-group">
  //               <h3>Manage Permissions</h3>
  //               <ul>
  //                 {Object.keys(permissions).map(
  //                   (key, index) => (
  //                     console.log(
  //                       key,
  //                       " this is all the key to give the role to the permission"
  //                     ),
  //                     (
  //                       <li
  //                         key={key}
  //                         style={{ listStyle: "none", marginBottom: "8px" }}
  //                       >
  //                         <label>
  //                           <input
  //                             type="checkbox"
  //                             checked={permissions[key]}
  //                             onChange={() => handleCheckboxChange(key)}
  //                           />
  //                           {` ${key}`}
  //                         </label>
  //                       </li>
  //                     )
  //                   )
  //                 )}
  //               </ul>
  //               {/* <pre>{JSON.stringify(permissions, null, 2)}</pre> */}
  //             </div>
  //           </Grid>
  //         </Grid>
  //         <div className={s["form-login-btn"]} onClick={() => createRoleFunc()}>
  //           <Custombutton>Submit</Custombutton>
  //         </div>
  //       </Card>
  //     </div>
  //   </>
  // );
};

export default AddRole;
